export type AwardTier = "gold" | "silver" | "bronze";

export type ProductAwardContainerType = "Keg" | "Cask" | "Bottle & Can";

export type SubCategoryAward = {
  subCategory: string;
  subCategoryMedal: AwardTier;
  type: ProductAwardContainerType;
};

export type ProductAwardData = {
  productId: number;
  overallCategory: string | null;
  overallCategoryMedal: AwardTier | null;
  subCategories: SubCategoryAward[];
};

export const productAwardData: ProductAwardData[] = [
  {
    productId: 94428,
    overallCategory: "Overall Champion of the Cask Beer Awards",
    overallCategoryMedal: "bronze",
    subCategories: [
      { subCategory: "Cask Pale Ale", subCategoryMedal: "gold", type: "Cask" },
      {
        subCategory: "Keg Amber, Brown & Red Ale",
        subCategoryMedal: "gold",
        type: "Keg",
      },
    ],
  },
  {
    productId: 86717,
    overallCategory: "Overall Champion of the Keg Beer Awards",
    overallCategoryMedal: "gold",
    subCategories: [
      {
        subCategory: "Keg Speciality & Flavoured Beer",
        subCategoryMedal: "gold",
        type: "Keg",
      },
    ],
  },
  {
    productId: 114612,
    overallCategory: "Overall Champion of the Keg Beer Awards",
    overallCategoryMedal: "bronze",
    subCategories: [
      {
        subCategory: "Keg Double & Triple IPA",
        subCategoryMedal: "gold",
        type: "Keg",
      },
    ],
  },
  {
    productId: 112910,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Cask Session Pale Ale",
        subCategoryMedal: "gold",
        type: "Cask",
      },
    ],
  },
  {
    productId: 109259,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Cask Imperial & Strong Beer",
        subCategoryMedal: "silver",
        type: "Cask",
      },
    ],
  },
  {
    productId: 85326,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Session Lager",
        subCategoryMedal: "gold",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 52277,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Premium Lager",
        subCategoryMedal: "gold",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 62084,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Premium Lager",
        subCategoryMedal: "silver",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 6892,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Premium Lager",
        subCategoryMedal: "bronze",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 100033,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can IPA",
        subCategoryMedal: "gold",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 11159,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can IPA",
        subCategoryMedal: "silver",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 2343,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Double & Triple IPA",
        subCategoryMedal: "silver",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 1884,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Speciality IPA",
        subCategoryMedal: "silver",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 3849,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Speciality IPA",
        subCategoryMedal: "bronze",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 83624,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Imperial & Strong Ale",
        subCategoryMedal: "bronze",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 15070,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Sour & Wild Ale",
        subCategoryMedal: "bronze",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 42791,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Continental Style",
        subCategoryMedal: "silver",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 2669,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Bottle/Can Speciality & Flavoured Beer",
        subCategoryMedal: "silver",
        type: "Bottle & Can",
      },
    ],
  },
  {
    productId: 36247,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Non-Alcoholic & Low ABV",
        subCategoryMedal: "silver",
        type: "Keg",
      },
    ],
  },
  {
    productId: 67199,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Session Lager",
        subCategoryMedal: "silver",
        type: "Keg",
      },
    ],
  },
  {
    productId: 108053,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Session Pale Ale",
        subCategoryMedal: "gold",
        type: "Keg",
      },
    ],
  },
  {
    productId: 90826,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Session Pale Ale",
        subCategoryMedal: "silver",
        type: "Keg",
      },
    ],
  },
  {
    productId: 104465,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Session Pale Ale",
        subCategoryMedal: "bronze",
        type: "Keg",
      },
    ],
  },
  {
    productId: 12659,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Pale Ale",
        subCategoryMedal: "bronze",
        type: "Keg",
      },
    ],
  },
  {
    productId: 18268,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Double & Triple IPA",
        subCategoryMedal: "silver",
        type: "Keg",
      },
    ],
  },
  {
    productId: 112740,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Speciality IPA",
        subCategoryMedal: "gold",
        type: "Keg",
      },
    ],
  },
  {
    productId: 61377,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Speciality IPA",
        subCategoryMedal: "silver",
        type: "Keg",
      },
    ],
  },
  {
    productId: 39000,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Amber, Brown & Red Ale",
        subCategoryMedal: "bronze",
        type: "Keg",
      },
    ],
  },
  {
    productId: 28702,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Imperial & Strong Ale",
        subCategoryMedal: "bronze",
        type: "Keg",
      },
    ],
  },
  {
    productId: 100229,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Sour & Wild Ale",
        subCategoryMedal: "gold",
        type: "Keg",
      },
    ],
  },
  {
    productId: 100930,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Sour & Wild Ale",
        subCategoryMedal: "bronze",
        type: "Keg",
      },
    ],
  },
  {
    productId: 108571,
    overallCategory: null,
    overallCategoryMedal: null,
    subCategories: [
      {
        subCategory: "Keg Continental Style Beer",
        subCategoryMedal: "gold",
        type: "Keg",
      },
    ],
  },
];
